const items = Array.from(document.querySelectorAll("[data-animate]"));

let observer;

function handleIntesect(item) {
    if (item.isIntersecting) {
        const { target } = item;
        const { animate } = target.dataset;

        if (animate) {
            target.setAttribute('data-animate', '')
        }
    }
}

function handleObserver(entries) {
    entries.forEach(handleIntesect);
}

function setup(el) {
    if (!observer) return;

    observer.observe(el);
}

function init() {
    if (!items) return;

    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.2,
    };

    observer = new IntersectionObserver(handleObserver, options);

    items.forEach(setup);
}

init();
